<template>
  <checkbox-list
    v-model="selectedTypes"
    :columns="columns"
    :options="recordTypes"
    field-name="record.view.types"
  />
</template>
<script>
import { types } from '@scholar/metadata-utils/main'
import CheckboxList from '#src/components/utils/fields/CheckboxList.vue'

export default {
  components: {
    CheckboxList
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    columns: {
      type: Number,
      default: 1,
      validator: prop => Number.isInteger(prop) && prop > 0
    }
  },
  emits: ['input', 'update:modelValue'],
  data() {
    return {
      recordTypes: types
    }
  },
  computed: {
    selectedTypes: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('update:modelValue', val)
      }
    }
  }
}
</script>
